import type { FieldId } from "../domain/types.js";
import type { CampaignAuthoredFieldSource } from "./types.js";
import { commonAuthoredFields } from "./common-fields.js";
import { chainAuthoredFields } from "./shared-grid.js";

const YAML_FILES = import.meta.glob("./sanctified/fields/*.yml", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

const overrideByFieldId = new Map<FieldId, string>();

for (const [filePath, yamlText] of Object.entries(YAML_FILES)) {
  const fileName = filePath.split("/").pop()!;
  const fieldId = fileName.replace(/\.yml$/i, "") as FieldId;
  overrideByFieldId.set(fieldId, yamlText);
}

const sanctifiedOverrideFields: CampaignAuthoredFieldSource = {
  get(fieldId: FieldId) {
    const yamlText = overrideByFieldId.get(fieldId);
    if (!yamlText) return null;
    return {
      fieldId,
      fileName: `${fieldId}.yml`,
      yamlText,
    };
  },
};

export const sanctifiedAuthoredFields: CampaignAuthoredFieldSource =
  chainAuthoredFields(sanctifiedOverrideFields, commonAuthoredFields);
